/**
 * Define a regex to validate US phone numbers
 */
export const usaPhoneRegex = /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/;
